import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Badge, Button } from '@mui/material';
import withRouter from 'react-router/withRouter';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import { tracking } from '../../../utils/tracking';

class ClientExpansionPortfolio extends React.PureComponent {
  render() {
    const {
      intl,
      isDisconnected,
      portfolioImage,
      policyAddImage,
      exportImage,
      analysisImage,
      portfolioOnClick,
      addPolicyOnClick,
      exportOnClick,
      analysisOnClick,
      staticContext,
      showDetails,
      ...rest
    } = this.props;

    return (
      <div className="client-border-first" {...rest}>
        <Grid
          container
          direction="row"
          spacing={0}
          style={{ paddingTop: '4px', paddingBottom: '4px', paddingLeft: '4px', paddingRight: '4px', width: '100%' }}
          className="ClientExpansionPortfolio"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {/* 查看保單 */}
          <Grid
            size={3}
            container
            className={!isDisconnected ? 'link' : 'clientNameHidden'}
            onClick={() => {
              tracking('Click on Portfolio - Client');
              portfolioOnClick();
            }}
            sx={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Grid className="client-expand-img-wrapper">
              <img alt="portfolio" src={portfolioImage} className="client-expand-img" />
            </Grid>

            <Grid size="grow">
              <Button className="action-button adviser-action" disabled={isDisconnected}>
                {intl.formatMessage({ id: 'Policy_Portfolio' })}
              </Button>
            </Grid>
          </Grid>

          {/* 添加保單 */}
          <Grid
            size={3}
            container
            className={!isDisconnected ? 'link' : 'clientNameHidden'}
            onClick={() => {
              tracking('Click on Add Policy - Client');
              addPolicyOnClick();
            }}
            sx={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Grid className="client-expand-img-wrapper">
              <img alt="portfolio" src={policyAddImage} className="client-expand-img" />
            </Grid>

            <Grid size="grow">
              <Button className="action-button adviser-action" disabled={isDisconnected}>
                {intl.formatMessage({ id: 'clientpage-add' })}
              </Button>
            </Grid>
          </Grid>

          {/* 保單pdf */}
          <Grid
            size={3}
            container
            className={!isDisconnected ? 'link' : 'clientNameHidden'}
            onClick={() => {
              tracking('Click on Policy PDF');
              if (exportOnClick) {
                exportOnClick();
              }
            }}
            sx={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Grid size="grow" className="client-expand-img-wrapper">
              <Badge
                className="button-text-badge"
                variant="dot"
                color="error"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <img alt="export" src={exportImage} className="client-expand-img" />
              </Badge>
            </Grid>

            <Grid size="grow">
              <Button className="action-button adviser-action" disabled={isDisconnected}>
                {intl.formatMessage({ id: 'policy-pdf' })}
              </Button>
            </Grid>
          </Grid>

          {/* 保障分析 */}
          <Grid
            size={3}
            container
            className={!isDisconnected ? 'link' : 'clientNameHidden'}
            onClick={() => {
              if (!isDisconnected) {
                tracking('Click on Analysis - Client');
                if (analysisOnClick) {
                  analysisOnClick();
                }
              }
            }}
            sx={{
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Grid className="client-expand-img-wrapper">
              <img alt="analysis" src={analysisImage} className="client-expand-img" />
            </Grid>

            <Grid size="grow">
              <Button className="action-button adviser-action" disabled={isDisconnected}>
                {intl.formatMessage({ id: 'client-protection-Analysis' })}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const container = connect(
  // Map state to props
  state => ({}),
  // Map actions to props
  {},
  // mergeProps
  null,
  // options
  {}
)(withRouter(ClientExpansionPortfolio));

export default injectIntl(container);
